module.exports = __webpack_public_path__ + "static/media/bgg.88b41544.png";